import { Pipe, PipeTransform } from '@angular/core';
import { formatDateTime } from '../utils/utils';

@Pipe({
  name: 'colombiaDate'
})
export class ColombiaDatePipe implements PipeTransform {

  transform(value: any, showTime: boolean = true): string {
    if (!value) return '';
    return formatDateTime(value, showTime, 'es-CO');
  }
}
